<script lang="ts">
import { defineComponent, ref } from "vue";
import DbButton from "../DB-Components/DbButton.vue";
import CalendarIcon from "@/components/icons/CalendarIcon.vue";
import { useStore } from "vuex";

export default defineComponent({
  emits: ["hideModal", "cancel"],
  setup(props, context) {
    const store = useStore();

    const slot = ref(store?.state?.TourStore?.slot);

    const slots = ref([
      [
        { id: 1, date: "31.09.2024", time: "06:00 - 06:30" },
        { id: 2, date: "31.09.2024", time: "07:00 - 07:30" },
      ],
      [
        { id: 3, date: "31.09.2024", time: "08:00 - 08:30" },
        { id: 4, date: "31.09.2024", time: "09:00 - 09:30" },
      ],
      [
        { id: 5, date: "31.09.2024", time: "10:00 - 10:30" },
        { id: 6, date: "31.09.2024", time: "11:00 - 11:30" },
      ],
      [
        { id: 7, date: "31.09.2024", time: "12:00 - 12:30" },
        { id: 8, date: "31.09.2024", time: "13:00 - 13:30" },
      ],
      [
        { id: 9, date: "31.09.2024", time: "14:00 - 14:30" },
        { id: 10, date: "31.09.2024", time: "15:00 - 15:30" },
      ],
    ]);

    const close = () => {
      slot.value = null;
      store.dispatch("TourStore/toggleSlotBook");
    };
    const submit = () => {
      store.dispatch("TourStore/selectSlot", slot.value).then((res) => {
        close();
        slot.value = res.data;
      });
    };
    const selectSlot = (slotData: {
      id: number;
      date: string;
      time: string;
    }) => {
      if (slot.value != null && slot.value?.id === slotData.id)
        return (slot.value = null);

      slot.value = slotData;
    };
    return {
      close,
      submit,
      store,
      slot,
      slots,
      selectSlot,
    };
  },
  components: { DbButton, CalendarIcon },
});
</script>
<template>
  <div
    id="tour-slot-book-selector"
    :class="store?.state?.TourStore?.slotBookModal ? 'flex' : 'hidden'"
    tabindex="-1"
    class="fixed top-20 left-0 right-0 px-5 flex items-center justify-center z-50"
  >
    <div class="relative w-full max-w-xl max-h-full z-50">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <div class="flex justify-between py-3 px-6">
          <div class="w-10"></div>
          <h2 class="text-2xl font-bold">{{ $t("tour.slotBooking") }}</h2>
          <div>
            <CalendarIcon></CalendarIcon>
          </div>
        </div>
        <!-- Modal body -->
        <div
          class="p-6 flex gap-2 flex-col w-full"
          data-testid="test-slot-book-tour"
        >
          <div v-for="(groupSlots, key) in slots" :key="key" class="flex gap-2">
            <div
              v-for="(slotData, index) in groupSlots"
              :key="index"
              @click="selectSlot(slotData)"
              :class="
                slot?.id === slotData.id ? 'border-green-400 bg-green-100' : ''
              "
              class="flex grow flex-col p-1 rounded border-2 border-black justify-center items-center"
            >
              <span>{{ slotData.date }}</span>
              <span>{{ slotData.time }}</span>
            </div>
          </div>
        </div>
        <div class="p-6 flex justify-between items-center gap-2">
          <DbButton
            @on-click="close"
            class="hydrated"
            variant="secondary-solid"
            >{{ $t("order.cancel") }}</DbButton
          >
          <DbButton
            v-if="!slot"
            variant="brand-primary"
            :disabled="true"
            class="hydrated"
            >{{ $t("tour.select_slot") }}</DbButton
          >

          <DbButton
            variant="brand-primary"
            @on-click="submit"
            v-else
            class="hydrated"
            >{{ $t("tour.confirm_slot") }}</DbButton
          >
        </div>
      </div>
    </div>
    <div
      modal-backdrop=""
      @click="close"
      :class="store?.state?.TourStore?.slotBookModal ? 'flex' : 'hidden'"
      class="bg-gray-900 bg-opacity-50 fixed inset-0 z-40"
    ></div>
  </div>
</template>
